import { FileWriter } from "@/platform"
import DataUtils from "./DataUtils"
import type MainProject from "./MainProject"
import { normalizeString } from "./gameBinUtils"

export function buildRuntimeGameBin(
  project: MainProject,
  maxWidth: number,
  maxHeight: number,
  guid: string,
  onlyOneBin = true,
  runtimeFontName?: string,
): Uint8Array {
  const bodyWriter = new FileWriter()
  project.systemData.writeGameBin(bodyWriter, runtimeFontName)

  if (onlyOneBin) {
    project.storyTree.writeGameBin(bodyWriter)
  }

  project.systemData.floatButton.writeGameBin(bodyWriter, DataUtils.engine_version)
  const bodyBytes = bodyWriter.toUint8Array()

  const writer = new FileWriter()
  writer.writeMSString('ORGDAT')
  writer.writeInt(DataUtils.engine_version)
  writer.writeInt(project.screenHash.width)
  writer.writeInt(project.screenHash.height)
  writer.writeInt(maxWidth)
  writer.writeInt(maxHeight)
  writer.writeString(guid)
  writer.writeString(normalizeString(project.storyTree.ProjectName))
  writer.writeInt(project.projectConstant.gameVersion)
  writer.writeInt(project.crc32)
  writer.writeInt(bodyBytes.length)
  writer.writeBytes(bodyBytes)
  return writer.toUint8Array()
}
